import * as actionTypes from "../constants";

const stepInitialState = {
  progress: 0,
  text: ""
};
const stepReducer = (state = stepInitialState, action) => {
  switch (action.type) {
    case actionTypes.STEP_CHANGE:
      return {
        ...state,
        progress: state.progress + action.payload.progress,
        text: action.payload.text
      };
    case actionTypes.CLEAR_STEPS:
      return {
        ...stepInitialState
      };
    default:
      return state;
  }
};

export default stepReducer;



// WEBPACK FOOTER //
// ./src/synchronization/SyncLoader/reducer.js